import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Field, Input } from '@fluentui/react-components'
import { findValue } from '../../../components/Formik/FormikField'
import { formatPostalCode } from '../../helpers/postalCodeHelper'

type Props = {
    fieldName: string
    labelKey?: string
    label?: string
    /** Country code that drives the formatting (NL/BE/DE). */
    country?: string
    required?: boolean
}

/**
 * Fluent v9 postal-code field, Formik-bound: formats the value per country on change. Replaces the
 * legacy v8 `PostalCodeField` (which isn't dark-mode compatible). Formatting lives in
 * {@link formatPostalCode}.
 */
export default function FormikPostalCodeField(props: Props): ReactElement {
    const { t: translate } = useTranslation()
    const { values, errors, setFieldValue, handleBlur } = useFormikContext<any>()

    const error = findValue(errors, props.fieldName)

    return (
        <Field
            label={props.label ?? (props.labelKey ? translate(props.labelKey) : undefined)}
            validationMessage={error}
            validationState={error ? 'error' : 'none'}
        >
            <Input
                value={findValue(values, props.fieldName) ?? ''}
                required={props.required}
                onChange={(_, data) => setFieldValue(props.fieldName, formatPostalCode(data.value, props.country))}
                onBlur={handleBlur(props.fieldName)}
                autoComplete="off"
                data-lpignore="true"
            />
        </Field>
    )
}
